<template>
  <div style="margin: 10px;">
    <md-layout
      v-if="certificationProcess.areas[this.activeArea].status <= 1"
      key="syncInformations"
    >
      <md-layout md-column v-if="queueStatus === 'creating'">
        <span class="md-title">CARREGANDO INFORMAÇÕES</span>
        <span class="md-caption"
        >Nesta etapa você precisa manter o WI-FI do seu celular ligado
          até que o envio esteja concluído.</span
        >
        <span class="md-caption">{{ queueLog }}</span>
        <md-progress md-indeterminate></md-progress>
      </md-layout>
      <md-layout md-column v-else-if="queueStatus === 'waiting'">
        <span class="md-title">ENVIO DAS FOTOS PARA NUVEM</span>
        <span
        >Esta é uma etapa do processo que visa enviar as fotos para nuvem e liberar espaço na memória do aparelho. </span
        >
        <p>Seu processo <b>NÃO SERÁ CONCLUÍDO</b> nesse momento, após finalizar a sincronização você poderá continuar
          normalmente.</p>
        <md-button class="md-accent md-raised" @click="startQueue" :disabled="!networkStatus"
        >Iniciar a Sincronização
        </md-button
        >
      </md-layout>
      <md-layout md-column v-else-if="queueStatus === 'running'">
        <span class="md-title">ENVIANDO FOTOS PARA NUVEM</span>
        <span class="md-caption"
        >Durante esse processo mantenha o aplicativo aberto e WI-FI
          ligado.</span
        >
        <md-progress
          :md-size="150"
          :md-progress="progress"
          class="md-warn"
        ></md-progress>
        <p>
          {{ queueLog }}
          Total: {{ queue.size }} Pendente: {{ queue.pending }}<br />
          Area Atual: {{ currentArea }}<br />
          Item Atual: {{ currentItem }}<br />
          Foto Atual: {{ currentPhoto }}
        </p>
      </md-layout>
    </md-layout>
    <md-layout v-else md-column>
      <span class="md-title"
      >SINCRONIZAÇÃO DA ÁREA <b>{{ currentArea }}</b> EFETUADA COM SUCESSO!
      </span>
      <span class="md-caption"
      >As fotos foram liberadas da memória, continue com seu processo de
        certificação.</span
      >
    </md-layout>
    <md-snackbar
      md-position="bottom center"
      ref="snackbar"
      :md-duration="Infinity"
    >
      <span
      >Sem conexão com a internet! Conecte a uma rede wi-fi e tente
        novamente.</span
      >
    </md-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PQueue from 'p-queue'

const logRequests = true // process.env.DEBUG_MODE

export default {
  name: 'sync-area-photos',
  data() {
    return {
      queueStatus: 'creating',
      queueLog: '',
      currentArea: '',
      currentItem: '',
      currentPhoto: '',
      progress: 0,
      totalItems: 0,
      faultyPhotos: [],
      networkStatus: true,
      finishedWithoutErrors: true,
      queue: { type: PQueue }
    }
  },
  computed: {
    ...mapState({
      certificationProcess: state => state.certificationProcess,
      activeArea: state => state.currPhotoArea,
      blh: state => state.blh,
      uid: state => state.uid
    })
  },
  beforeMount() {
    window.addEventListener('online', this.handleConnectivityChange)
    window.addEventListener('offline', this.handleConnectivityChange)
    this.networkStatus = navigator.onLine
    this.FETCH_DATA().then(() => {
      this.$nextTick(() => {
        if (this.certificationProcess.areas[this.activeArea].status <= 1) {
          this.createQueue()
        }
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('online', this.handleConnectivityChange)
    window.removeEventListener('offline', this.handleConnectivityChange)
    console.log(this.queue)
    if (this.queue.constructor === PQueue) {
      this.queue.pause()
      this.queue.clear()
    }
  },
  updated() {
    if (!this.networkStatus) {
      this.$refs.snackbar.open()
    }
  },
  methods: {
    ...mapActions([
      'FETCH_DATA',
      'FETCH_IMAGE',
      'UPLOAD_FILE',
      'PHOTO_SYNC',
      'SET_AREA'
    ]),
    startQueue() {
      logRequests && console.log('[Queue Started]')
      // clear the faulty photos
      this.faultyPhotos = []
      this.queueStatus = 'running'
      this.queue.start()
    },
    createQueue() {
      this.queueStatus = 'creating'
      this.queue = new PQueue({ concurrency: 1, autoStart: false })
      logRequests && console.log('Creating Queue...')
      let count = 0

      this.queue.on('active', () => {
        this.queueLog = `Trablhando no item #${++count}. Total: ${
          this.queue.size
        } Pendente: ${this.queue.pending}`
        this.progress = parseInt((count / this.totalItems) * 100, 10)
        logRequests && console.log(this.queueLog)
      })

      this.queue.on('error', error => {
        this.finishedWithoutErrors = false
        console.log(error)
      })

      let area = this.certificationProcess.areas[this.activeArea]

      this.queueLog = `Carregando Area ${area.name}`

      this.queueAreaStructureUpload(area, this.activeArea)

      this.queueAreaVerticeUpload(area, this.activeArea)

      this.queueLog = 'Areas carregadas com sucesso...'
      this.totalItems = this.queue.size
      this.queueStatus = 'waiting'

      this.queue.onIdle().then(() => {
        // TODO: check if errors before updating the area status...
        console.log(this.faultyPhotos)
        if (this.finishedWithoutErrors && this.faultyPhotos.length <= 0) {
          console.log('Area finished without errors or faultyphotos')
          area.status = 2
          this.SET_AREA({ area: area, key: this.activeArea })
        }
      })

      logRequests &&
      console.log(`[Queue created with ${this.queue.size} items pending]`)
    },
    queueAreaStructureUpload(area, areaIndex) {
      var vm = this
      if (!area.structures) {
        logRequests && console.warn(`Area without structures ${area.name}`)
        return Promise.resolve() // This is normal, we dont throw an error here.
      }

      for (
        let structureIndex = 0;
        structureIndex < area.structures.length;
        structureIndex++
      ) {
        let structure = area.structures[structureIndex]
        if (!structure || !structure.photos) {
          logRequests &&
          console.warn(
            `Structures structureIndex:${structureIndex} null or dont have photos`
          )
          continue // This is not supposed to happen...
        }
        vm.queuePhotoUpload(structure, area, structureIndex, areaIndex)
      }
    },
    queueAreaVerticeUpload(area, areaIndex) {
      var vm = this
      if (!area.vertices) {
        logRequests && console.warn(`Area without vertices ${area.name}`)
        return Promise.resolve() // This is not supposed to happen...
      }
      for (
        let verticeIndex = 0;
        verticeIndex < area.vertices.length;
        verticeIndex++
      ) {
        let vertice = area.vertices[verticeIndex]
        if (!vertice || !vertice.photos) {
          logRequests &&
          console.warn(
            `Vertice verticeIndex:${verticeIndex} null or dont have photos`
          )
          continue
        }
        vm.queuePhotoUpload(vertice, area, verticeIndex, areaIndex)
      }
    },
    queuePhotoUpload(item, area, itemIndex, areaIndex) {
      var vm = this
      logRequests &&
      console.log(
        `Queueing ${item.photos.length} photos for ${area.name}-${item.name}`
      )

      if (!item.photos) {
        // Checking for nulls again just to be sure
        logRequests &&
        console.warn(`Item without photos: ${item.name}-${area.name}`)
        return Promise.resolve()
      }

      for (let photoIndex = 0; photoIndex < item.photos.length; photoIndex++) {
        let photo = item.photos[photoIndex]
        if (!photo) {
          logRequests &&
          console.warn(
            `Photos is empty: [${photoIndex}] ${item.name}-${area.name}`
          )
          return Promise.reject(
            `Photos is empty: [${photoIndex}] ${item.name}-${area.name}`
          )
        }
        // If photo has not been synced yet
        if (photo.status !== 2) {
          vm.queue.add(() =>
            vm.upload(photo, area, item, photoIndex, itemIndex, areaIndex)
          )
        }
      }
    },
    upload(photo, area, item, photoIndex, itemIndex, areaIndex) {
      var vm = this

      if (!photo) {
        return Promise.reject(`Item ${item.name} photo is null`)
      }

      if (!photo.image) {
        return Promise.reject(
          `Item ${item.name} photo ${photo.name} image is null`
        )
      }

      return this.FETCH_IMAGE(photo.image).then(imgBlob => {
        if (!imgBlob) {
          logRequests &&
          console.warn(
            `Image not found, may be corrupted, need to re-take it`
          )
          return Promise.reject(
            `Image not found, may be corrupted, need to re-take it`
          )
        }

        vm.currentArea = area.name
        vm.currentItem = item.name
        vm.currentPhoto = photo.name

        let fileName = `${vm.blh.currentYear}_${vm.uid}_${photo.image}.png`
        let file = new File([imgBlob], fileName)
        logRequests &&
        console.log(
          `Uploading file: ${fileName}.jpg with size: ${file.size}`
        )
        return vm.UPLOAD_FILE({ image: file, name: fileName }).then(fileUrl => {
          logRequests &&
          console.log(
            `File uploaded: ${fileName}.jpg with size: ${file.size}`
          )
          return vm.PHOTO_SYNC({
            photoId: photoIndex,
            areaId: areaIndex,
            itemId: itemIndex,
            type: item.type,
            status: 2,
            image: photo.image,
            url: fileUrl
          })
        }).catch((error) => {
          console.log(`Error uploading ${error}`)
          this.faultyPhotos.push(photo)
        })
      })
    },
    handleConnectivityChange() {
      this.networkStatus = navigator.onLine
      logRequests && console.log('handleConnectiveChange:' + this.networkStatus)
      if (this.networkStatus) {
        this.$refs.snackbar.close()
      } else {
        this.queue.pause()
        this.queueStatus = 'waiting'
        this.$refs.snackbar.open()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SyncAreaPhotos.vue?922ae7bc